import { prototypal } from "./_utils";
export const reverse = prototypal("reverse", true);
